var escape = require("../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@font-face {\r\n  font-family: \"Impact\";\r\n  src: url(" + escape(require("./impactreg.woff")) + ") format(\"woff\");\r\n}\r\n", ""]);

// exports
